export default __webpack_public_path__ + "static/media/miscellaneous02.30fd4916.png";